export default "__VITE_ASSET__DKpJmsUC__"